import React from 'react';
import { Box, LinearProgress } from '@mui/material';

const LoadingScreen: React.FC = () => {

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#ffffff',
      }}
    >
      {/* Logo and Text Container */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          mb: 3,
        }}
      >
        {/* WAI Logo */}
        <img 
          src="https://platform.waiin.com/assets/portal-assets/WAi-logo.png"
          alt="Wai Technologies" 
          style={{
            height: 'auto',
            width: 'auto',
            maxHeight: '50px',
          }}
        />
      </Box>

      {/* Progress Bar */}
      <Box sx={{ width: '180px' }}>
        <LinearProgress 
          sx={{
            height: 4,
            borderRadius: 2,
            backgroundColor: '#E8E8E8',
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#4169E1',
              borderRadius: 2,
            }
          }}
        />
      </Box>
    </Box>
  );
};

export default LoadingScreen;
